import type { TargetProduct } from '@post-office/browser--puma/common/in-app/cjn-nav4/types';

import {
	ConfluenceCloudCcpId,
	type ValidProductCcpId,
} from '@post-office/message-template-contracts/message-template-metadata';

export const targetProduct: { productId: ValidProductCcpId; productKey: TargetProduct } = {
	productId: ConfluenceCloudCcpId,
	productKey: 'confluence',
};
